const klarnaSelector = store => store.klarna;

export default klarnaSelector;
